<app-fullscreen-layout>
  <app-page-header>
    <app-page-title>
      {{ 'cockpit.organizations.page.title' | transloco }}
    </app-page-title>
    <div slot="end" class="flex items-center gap-3">
      <a routerLink="/excellence-ui-demo" *appFeatureEnabled="'showExcellenceUiDocs'">
        <ui-button mode="outlined">
          <ng-icon name="heroBookOpen" size="20" slot="start" class="!block" />
          {{ 'cockpit.organizations.uiDocsButton' | transloco }}
        </ui-button>
      </a>
      <ui-switch-bar
        *hasRole="['USER_ADMIN']"
        value="standard"
        class="w-[78px] inline-block"
        (valueChange)="onSwitchBarChange($event)"
      >
        <ui-switch-bar-option
          value="standard"
          [uiTooltip]="'cockpit.organizations.switchView.standard' | transloco"
        >
          <ng-icon name="heroSquares2x2" size="20" class="!block" />
        </ui-switch-bar-option>
        <ui-switch-bar-option
          value="broker"
          [uiTooltip]="'cockpit.organizations.switchView.admin' | transloco"
        >
          <ng-icon name="heroListBullet" size="20" class="!block" />
        </ui-switch-bar-option>
      </ui-switch-bar>
      <app-user-profile-button>
        <div class="flex items-center gap-3 cursor-pointer">
          <app-current-user-avatar />
          <app-current-username />
        </div>
      </app-user-profile-button>
    </div>
  </app-page-header>
  <div slot="sticky-header" class="flex gap-3 sm:max-w-[392px]">
    <ui-input-simple
      #search
      type="search"
      class="flex-1"
      data-track="cockpit-organization-search"
      [placeholder]="'cockpit.organizations.page.searchPlaceholder' | transloco"
      [attr.aria-label]="'cockpit.organizations.page.searchAriaLabel' | transloco"
      [value]="store.searchQuery()"
      (fieldValueChange)="searchQuery.next($event)"
    >
      <div slot="start" class="text-on-surface-disabled dark:text-on-surface-disabled-darkmode">
        <ng-icon name="heroMagnifyingGlass" size="13" class="!block" />
      </div>
    </ui-input-simple>
    <ui-button
      class="max-sm:hidden"
      data-track="cockpit-organization-create-button"
      [routerLink]="['/organizations/create']"
      disableInDemoMode
    >
      <ng-icon slot="start" name="heroPlus" size="20" class="!block" />
      {{ 'cockpit.organizations.page.createButtonLabel' | transloco }}
    </ui-button>
    <ui-button
      [iconOnly]="true"
      class="min-sm:hidden"
      [attr.aria-label]="'cockpit.organizations.page.createButtonAriaLabel' | transloco"
      [routerLink]="['/organizations/create']"
      disableInDemoMode
    >
      <ng-icon name="heroPlus" size="20" class="!block" />
    </ui-button>
  </div>
  <div class="flex flex-col gap-4">
    @if (store.allLoadingError()) {
      <app-error-page
        [error]="store.allLoadingError()"
        (clickBack)="onClickBack()"
        class="block"
        style="height: calc(100vh - 5rem - 10rem)"
      />
    } @else {
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        @for (orga of store.entitiesList(); track orga.id) {
          <div
            class="w-full bg-surface-magic dark:bg-surface-magic-darkmode rounded-lg shadow-xs outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode flex flex-col"
            data-track="cockpit-organization-card"
            [attr.data-organization-id]="orga.id"
          >
            <div class="flex flex-col w-full">
              <div class="pt-5 px-6 flex gap-4 justify-between items-center">
                <div
                  class="flex-1 text-on-surface dark:text-on-surface-darkmode font-semibold leading-6 line-clamp-1"
                >
                  {{ orga.data?.name }}
                </div>
                <ui-button mode="outlined" [routerLink]="['/organizations', orga.id]">
                  {{ 'cockpit.organizations.page.openButton' | transloco }}
                  <ng-icon name="heroArrowRight" size="20" class="!block size-5" slot="end" />
                </ui-button>
              </div>
              <div class="flex justify-center items-center w-full py-10">
                <div
                  class="w-60 max-w-60 max-h-60 p-5 bg-surface rounded-2xl aspect-square flex items-center justify-center"
                >
                  <img
                    [src]="orga.data | profilePicture"
                    [attr.alt]="'cockpit.organizations.page.profilePictureAlt' | transloco"
                    class="object-contain"
                  />
                </div>
              </div>
              <div
                class="flex-none py-4.5 px-6 flex gap-5 border-t border-outline dark:border-outline-darkmode"
              >
                <div
                  class="text-on-surface-variant dark:text-on-surface-variant-darkmode text-sm leading-5 font-normal line-clamp-1 flex-1"
                >
                  @if (orga.data?.metadata?.createdAt; as createdAt) {
                    {{ 'cockpit.organizations.page.createdLabel' | transloco }}
                    {{ createdAt | date: 'dd.MM.yyyy' }}
                  } @else {
                    &nbsp;
                  }
                </div>
              </div>
            </div>
          </div>
        }
        @if (store.allLoading()) {
          <app-organization-card-skeleton />
          <app-organization-card-skeleton />
        }
        <div
          class="w-full min-h-[401px] h-full p-6 bg-surface dark:bg-surface-darkmode rounded-lg shadow-xs outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode outline-dashed inline-flex flex-col justify-center items-center gap-3"
        >
          <div class="inline-flex justify-end items-center">
            <div class="flex justify-start items-center gap-3">
              <ui-button
                mode="outlined"
                [routerLink]="['/organizations/onboarding']"
                disableInDemoMode
              >
                <ng-icon name="heroPlus" size="20" class="!block size-5" slot="start" />
                {{ 'cockpit.organizations.page.createNewButton' | transloco }}
              </ui-button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</app-fullscreen-layout>
<app-demo-info-banner *isDemoMode class="block fixed bottom-0 left-0 right-0 z-50" />
<app-feedback-fab
  *appTechnicalMonitoringEnabled
  class="fixed bottom-5 right-5"
  demoModeActive="bottom-17"
/>
